<template>
  <div class="jxs-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="店面状态">
              <el-select v-model="searchForm.mark" style="width: 120px" @keyup.enter.native="SearchJxs" filterable clearable>
                <el-option label="已开业" :value="1"/>
                <el-option label="装修中" :value="2"/>
                <el-option label="设计中" :value="3"/>
                <el-option label="已选址" :value="4"/>
                <el-option label="已终止" :value="0"/>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="SearchJxs"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="SearchJxs">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="客户名称"
                    width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.allname && scope.row.allname.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.allname }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="联系电话"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.tel}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="店面状态"
                    width="100"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag size="mini" v-if="scope.row.mark===1">已开业</el-tag>
                      <el-tag type="danger" size="mini" v-if="scope.row.mark===0">已终止</el-tag>
                      <el-tag type="warning" size="mini" v-if="scope.row.mark===2">装修中</el-tag>
                      <el-tag type="warning" size="mini" v-if="scope.row.mark===3">设计中</el-tag>
                      <el-tag type="warning" size="mini" v-if="scope.row.mark===4">已选址</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="所在地区"
                    width="180"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.province}} {{scope.row.city}} {{scope.row.county}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="默认南北工艺"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{ scope.row.craft == 1 ? '南' : (scope.row.craft == 2 ? '北' : '-') }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="主用户"
                    width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" type="danger" size="mini" v-if="scope.row.usertel==null||scope.row.usertel==''">无主用户</el-tag>
                      <span v-if="scope.row.usertel!=null&&scope.row.usertel!=''">{{scope.row.username}}（{{scope.row.usertel}}）</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="代理品牌"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.brands}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    fixed="right"
                    align="center"
                    show-overflow-tooltip
                    label="操作"
                    width="110"
                  >
                    <template slot-scope="scope">
                      <el-button v-if="scope.row.vip == 1" plain size="mini" type="warning" @click.stop="setVip(scope.row, 0)">取消VIP</el-button>
                      <el-button v-else size="mini" plain type="primary" @click.stop="setVip(scope.row, 1)">设为VIP</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDealerList, updateDealerVip } from '@/api/work'

export default {
  name: 'jxs',
  computed: {
    user: getUser
  },
  data() {
    return {
      searchForm: {
        mark: null,
        search: ''
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0
    }
  },
  created() {
    this.getData()
  },
  methods: {
    SearchJxs() {
      if (this.searchForm.search != null && this.searchForm.search.trim() != '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        content: this.searchForm.search,
        mark: this.searchForm.mark,
        page: this.currentPage,
        limit: this.pageSize
      }
      getDealerList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/dealer/' + row.delid })
    },
    setVip(row, vip) {
      this.$confirm('您确定要将该经销商' + (vip == 1 ? '设为' : '取消') + 'VIP吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: vip == 1 ? 'success' : 'warning'
      }).then(() => {
        updateDealerVip({ delid: row.delid, vip }).then(response => {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.getData()
        })
      }).catch(() => {

      })
    },
  }
}
</script>

<style lang="scss" scoped>
.jxs-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
